// extracted by mini-css-extract-plugin
module.exports = {"datatable":"DataTable_datatable__20iRO"};